import { useQuery } from "@tanstack/react-query";
import { StatCounts } from "@/model";
import statisticsRepository from "@/repository/statisticsRepository";


const emptyResponse = {
    domain: {},
    skill: {},
    intent: {},
    request: {}
};

const getData = async (agentId: number, start?: string, end?: string) => {
    if (!start || !end) {
        return emptyResponse;
    }
    const res = await statisticsRepository.getStatCounts(agentId, start, end);
    return res.data?.data || emptyResponse;
};

export const useStatCounts = (agentId: number, start?: string, end?: string) => {
    return useQuery<StatCounts>({
        queryKey: [
            "statistics",
            "counts",
            "agent", agentId,
            "start", start,
            "end", end,
        ],
        queryFn: async () => getData(agentId, start, end),
        retry: false
    });
};
